<template>
  <section id="obras" class="grey lighten-4">
    <v-container class="extra-padding" fluid>
      <v-row justify="center" align="center" class="white--text back">
        <v-col cols="12" md="5" class="px-md-16 py-md-0 pa-sm-16 pa-16">
          <h1 class="font-weight-black text-h5 text-uppercase">
            Conocé nuestras últimas obras
          </h1>
          <p class="font-weight-light">
            Conocé las últimas obras en las que trabajamos, siempre garantizando
            experiencia y profesionalismo para nuestros clientes
          </p>
          <v-btn color="white" to="nuestras-obras">Nuestras obras</v-btn>
        </v-col>
        <v-col cols="12" md="7" class="pa-0 ma-0 d-none d-md-inline">
          <v-parallax
            dark
            :src="require('@/assets/section/section-obras.jpeg')"
            height="300"
          >
            <div class="diagonal"></div>
          </v-parallax>
        </v-col>
      </v-row>
    </v-container>
    <vertical-divider :class="'vertical'" class="mb-0" />
  </section>
</template>

<script>
export default {
  name: "Obras",
  components: {
    VerticalDivider: () => import("@/components/shape/VerticalDivider.vue")
  }
};
</script>

<style scoped>
.back {
  background-image: linear-gradient(
    to right,
    #03123b,
    #0a2451,
    #123667,
    #194a7e,
    #205f95
  );
}
.diagonal {
  position: absolute;
  height: 100%;
  width: 200px;
  margin-left: -43px;
  background-color: #11305f;
  transform: skewX(-10deg);
  z-index: 9999;
}
.vertical {
  margin-top: -4.75em !important;
}
/** For tablet devices **/
@media (min-width: 768px) and (max-width: 1023px) {
  .vertical {
    margin-top: -2.6em !important;
  }
}

/** For mobile devices **/
@media (max-width: 767px) {
  .vertical {
    margin-top: -2.5em !important;
  }
}
</style>
